var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import { useTabContext } from '../../context/useTabContext';
import { TabsTestIdFactory } from '../../interactions';
import styles from './TabPanel.module.css';
export const TabPanel = ({ children, isFocusable = true, scrollableY, shouldKeepHidden = false, tabId, }) => {
    _react_refresh_temp_2();
    const { activeTabId } = useTabContext();
    if (!shouldKeepHidden && !(activeTabId === tabId)) {
        return null;
    }
    return (_jsx("div", { "aria-labelledby": `tab-${tabId}`, className: C(styles.Container, scrollableY && styles.ScrollableY), "data-testid": TabsTestIdFactory.getTabPanelTestId(tabId), id: `panel-${tabId}`, role: "tabpanel", ...(isFocusable && { tabIndex: 0 }), ...(!(activeTabId === tabId) &&
            shouldKeepHidden && { hidden: true }), children: children }));
};
_react_refresh_temp_1 = TabPanel;
$RefreshReg$(_react_refresh_temp_1, "TabPanel");
_react_refresh_temp_2(TabPanel, "PbGZs9LKXahEzrriTfNUfRahb1A=", false, () => [useTabContext]);
